import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/index'
import News from '@/components/news/news'
import NewsMore from '@/components/newsMore/newsMore'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path:'/',
      redirect:'/index'
    },
    {
      path:'/index',
      name:'Index',
      component: Index
    },
    {
      path:'/newsMore',
      name:'NewsMore',
      component: NewsMore
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js